<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Domain</th>
            <th>Renewal</th>
            <th>Client</th>
            <th>Order</th>
            <th>Type</th>
            <th>Expires</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="domain in domains" :key="domain.id">
            <td>
              <i class="fas fa-hammer orange" title="building" v-if="domain.status === 'building'"></i>
              <i class="fa fa-check green" title="built" v-if="domain.status === 'built'"></i>
              <router-link :to="{path: '/pbn/' + domain.punyDomain }" v-if="domain.deleted" class="red"><i class="fa fa-remove"></i> {{ domain.domain }}</router-link>
              <router-link :to="{path: '/pbn/' + domain.punyDomain }" v-else>{{ domain.domain }}</router-link>
            </td>
            <td>
              <i class="fa fa-redo green" v-if="domain.integrations.registrar && domain.integrations.registrar.autoRenew" v-tooltip="'Auto Renew On'"></i>
              <i class="fa fa-ban gray" v-else v-tooltip="'Manual Renewal'"></i>
              <i class="fa fa-calendar-times red" v-tooltip="'Let Expire'" v-if="domain.integrations.registrar && domain.integrations.registrar.extraData && domain.integrations.registrar.extraData.letExpire"></i>
            </td>
            <td>{{ domain.client ? domain.client.name : '/' }}</td>
            <td>{{ domain.order ? domain.order.name : '/' }}</td>
            <td>{{ domain.type }}</td>
            <td>{{ domain.expires ? $moment(domain.expires.date).format('DD.MM.Y') : '/'}} ({{ domain.expiresIn || '/' }} days)</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { PBNS_SET } from '../../../../../store/mutation-types'
import { eventBus } from '../../../../../main'

export default {
  data () {
    return {
      domains: []
    }
  },
  mounted () {
    this.getDomains()
    eventBus.$on('reloadRegistrarDomains', () => {
      this.getDomains()
    })
  },
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    getDomains () {
      axios.get('/pbn/list?deleted=all&registrars=' + this.$route.params.id).then(r => {
        this.domains = (r.data.data || []).sort((a, b) => a.expiresIn - b.expiresIn)
        this.$store.commit(PBNS_SET, r.data.data)
        this.meta = r.data.meta
      }).catch(e => {
        this.$toastr.error(e, 'Whoopsy Daisy')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrar/Tabs/DomainList.vue